/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two or more numeric columns draw grouped bars with a legend.`)
};

const es_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos o más columnas numéricas dibujan barras agrupadas con una leyenda.`)
};

const de_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei oder mehr numerische Spalten zeichnen gruppierte Balken mit einer Legende.`)
};

const nl_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee of meer numerieke kolommen tekenen gegroepeerde staven met een legenda.`)
};

const fr_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux colonnes numériques ou plus dessinent des barres groupées avec une légende.`)
};

const it_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due o più colonne numeriche disegnano barre raggruppate con una legenda.`)
};

const pt_br2_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas ou mais colunas numéricas desenham barras agrupadas com legenda.`)
};

const pt_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas ou mais colunas numéricas desenham barras agrupadas com uma legenda.`)
};

const ja_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値列が2つ以上ある場合、凡例付きのグループ化棒グラフが描画されます。`)
};

const zh_bar_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两列或以上数值绘制出带图例的分组柱状图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_ex2", locale)
	if (locale === "en") return en_bar_ex2(inputs)
	if (locale === "es") return es_bar_ex2(inputs)
	if (locale === "de") return de_bar_ex2(inputs)
	if (locale === "nl") return nl_bar_ex2(inputs)
	if (locale === "fr") return fr_bar_ex2(inputs)
	if (locale === "it") return it_bar_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_bar_ex2(inputs)
	if (locale === "pt") return pt_bar_ex2(inputs)
	if (locale === "ja") return ja_bar_ex2(inputs)
	return zh_bar_ex2(inputs)
};